import {Optional} from "../../js/util/Optional";
import {HistoricalPriceResponse} from "../price/historical/HistoricalPriceModels";

export type ProducerFn = (underlying: string, asAt: string) => Promise<HistoricalPriceResponse>;

export class HistoricalOptionCache {

    private cache = new Map<string, Map<string, Promise<HistoricalPriceResponse>>>();

    public getOrCompute(underlying: string,
                        asAt: string,
                        producer: ProducerFn): Promise<HistoricalPriceResponse> {
        const underlyingCache = Optional.of(this.cache)
                                        .map(c => c.get(underlying))
                                        .orElseGet(() => new Map<string, Promise<HistoricalPriceResponse>>());
        const asAtCache = Optional.of(underlyingCache)
                                  .map(c => c.get(asAt))
                                  .map(c => Promise.resolve(c))
                                  .orElseGet(() => producer(underlying, asAt));
        this.cache.set(underlying, underlyingCache);
        underlyingCache.set(asAt, asAtCache);
        return asAtCache;
    }
}
